<template>
    <el-aside>
        <div class="sidebar-menu">
            <el-menu
                :default-active="activeMenu"
                :unique-opened="true"
                :default-openeds="['system']"
                background-color="#fff"
                text-color="#666"
                :active-text-color="variables.primaryColor"
                :router="true">
                <el-menu-item index="live" route="/live" @click.native="clearAlive">
                    <i class="iconfont icon-icon_nav_zhiboguanli_n"></i>
                    <span slot="title"> 直播管理</span>
                </el-menu-item>
                <el-menu-item index="application" route="/application" v-if="!role">
                    <i class="iconfont icon-icon_nav_zuzhiguanli_n"></i>
                    <span slot="title"> 应用管理</span>
                </el-menu-item>
                <el-submenu index="system" v-if="role">
                    <template slot="title">
                        <i class="iconfont icon-icon_nav_xitongguanli_n"></i>
                        <span slot="title"> 系统管理</span>
                    </template>
                    <el-menu-item index="orgin" route="/orgin">组织管理</el-menu-item>
                    <el-menu-item index="resource" route="/resource">资源管理</el-menu-item>
                    <el-menu-item index="interface" route="/interface">接口管理</el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
    </el-aside>
</template>

<script>
import variables from '@/styles/variables.scss'
import { getuserInfo } from '@/utils/auth'

export default {
    inject: ['reload'],
    name: 'sidebar',
    data() {
        return {
            role: getuserInfo() ? JSON.parse(getuserInfo()).is_admin : false
        }
    },
    computed: {
        activeMenu() {
            const route = this.$route.path.split('/')
            return route[1]
        },
        variables() {
            return variables
        }
    },
    methods: {
        clearAlive() {
            this.reload()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.el-aside{
    width: 200px!important;
    background-color: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.08);
    padding: 12px 0;
    .sidebar-menu{
        ::v-deep .el-menu{
            border-right: 0;
            &>li.el-menu-item{
                border-right: 4px solid #fff;
                &:hover,&.is-active{
                    color: $primaryColor!important;
                    border-right: 4px solid $primaryColor;
                    background-color: $menuCurrBgColor!important;
                    i{
                        color: $primaryColor!important;
                    }
                }
            }
            li{
                i{
                    font-size: 18px;
                    color: #A3A4B3;
                    margin-right: 8px;
                }
                span{
                    font-size: 16px;
                }
            }
            .el-submenu{
                &:hover{
                    .el-submenu__title{
                        border-right: 4px solid $primaryColor;
                    }
                }
                .el-submenu__title{
                    border-right: 4px solid #fff;
                }
                .el-menu{
                    position: relative;
                    padding-left: 40px;
                    margin: 8px 0;
                    .el-menu-item{
                        position: relative;
                        font-size: 16px;
                        color: #909399!important;
                        padding: 0 0 0 32px;
                        min-width: inherit;
                        border-right: 0;
                        &:hover{
                            background-color: #fff!important;
                            color: $primaryColor!important;
                        }
                        &.is-active{
                            background-color: #fff!important;
                            border-right: 0;
                            color: $primaryColor !important;
                            &::before{
                                content: "";
                                position: absolute;
                                width: 1px;
                                height: 20px;
                                left: 0;
                                top: 0;
                                bottom: 0;
                                margin: auto;
                                z-index: 1;
                                background-color: $primaryColor;
                            }
                        }
                    }
                    &::before{
                        content: "";
                        position: absolute;
                        width: 1px;
                        height: calc(100% - 25px);
                        background-color: #DCDFE6;
                        top: 0;
                        bottom: 0;
                        left: 40px;
                        margin: auto;
                        z-index: 1;
                    }
                }
            }
        }
        ::v-deep.el-submenu.is-active .el-submenu__title{
            border-right:4px solid $primaryColor;
            background-color: $menuCurrBgColor!important;
            i{
                color: $primaryColor!important;
            }
        }
    }
}
.el-menu{
    li:hover,li.is-active{
        i{
            color: $primaryColor!important;
        }
        ::v-deep.el-submenu__title{
            background-color: $menuCurrBgColor!important;
            border-right:4px solid $primaryColor;
            color: $primaryColor!important;
        }
    }
}
.el-menu-item{
    height: 40px;
    line-height: 40px;
    margin-bottom: 8px;
}
.el-submenu{
    ::v-deep.el-submenu__title{
        height: 40px;
        line-height: 40px;
    }
    .el-menu-item{
        height: 46px;
        line-height: 46px;
        margin-bottom: 0;
    }
}
</style>
